import { dataExport } from './export';
import { statistics } from './statistics';

export const webEvents = {
  dataExport,
  statistics,
};
